import angular from 'angular';
import DynamicReportsViewModel from '../Components/DynamicReports/DynamicReportsViewModel';


export default angular
    .module('app.shared.dashboardReports', [])
    .controller("dynamicReportsViewModel", DynamicReportsViewModel)
    .name;